import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import { getPublicAssetUrl } from '@/app/utils/getPublicAssetUrl';

type SidebarBrandProps = {
  collapsed: boolean;
  onToggleCollapsed: () => void;
};

export function SidebarBrand({
  collapsed,
  onToggleCollapsed,
}: SidebarBrandProps) {
  const apiUrl = import.meta.env.VITE_API_URL?.replace(/\/$/, '') || '';
  const logoUrl = `${apiUrl}/api/v1/app-logo/logo`;
  const logoMarkUrl = getPublicAssetUrl('Logo_Export_EVIMO_LOGO-MARK_BLUE.svg');
  const logoFallbackUrl = getPublicAssetUrl('assets/evimo_logo.png');

  return (
    <div className="evimo-nav-brand">
      <Link
        to="/home"
        className="evimo-nav-brand__link"
        aria-label="EVIMO home"
      >
        {collapsed ? (
          <img
            className="evimo-nav-brand__mark"
            src={logoMarkUrl}
            alt="EVIMO"
            width={22}
            height={22}
          />
        ) : (
          <img
            className="evimo-nav-brand__logo"
            src={logoUrl}
            alt="EVIMO"
            width={120}
            height={24}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = logoFallbackUrl;
            }}
          />
        )}
      </Link>

      <Button
        type="text"
        className="evimo-nav-brand__toggle"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        onClick={onToggleCollapsed}
      />
    </div>
  );
}
